import { render, staticRenderFns } from "./RidersExport.vue?vue&type=template&id=22426476&scoped=true"
import script from "./RidersExport.vue?vue&type=script&lang=js"
export * from "./RidersExport.vue?vue&type=script&lang=js"
import style0 from "./RidersExport.vue?vue&type=style&index=0&id=22426476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22426476",
  null
  
)

export default component.exports